import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Dropdown } from 'primereact/dropdown';
import FieldCombo from '../combos/FieldCombo';
import FaDate from '../shared/FaDate';
import { Col, Form, Row } from 'react-bootstrap';


export default function Courses(props) {
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [listVisible, setListVisible] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [code, setCode] = useState();
    const [name,setName] = useState("");
    const [degree, setDegree] = useState();
    const [field, setField] = useState(null);
    const [scoreType, setScoreType] = useState(0);
    const [selectedScorType, setSelectedScoreType] = useState("");
    const [unit, setUnit] = useState(1);


    useEffect(() => {

    }, []);
    const loadItems = function(){
      setListVisible(true);
      setLoading(true);
      
      var deg = 0;
      if(degree != null) deg = degree;
      var fieldId = "";
      if(field != null)
        if(field.id != null) fieldId = field.id ;
      var params = {login:util.getTrustedUser(), degree:deg, fieldId:fieldId, lastIndex:0, pageSize:0};
      var url = config.Server+`/basic/course/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
    }
    const addNewItem = function(){
      setCurrentItem(null);
      var max = 0;
      if(items != null){
        for(var i=0;i<items.length;i++){
          if(items[i].code > max) max = items[i].code;
        }
        max = max + 1;
      }
      setCode(max);
      setName("");
      setScoreType(1);
      setSelectedScoreType({ name: 'عددی', code: '1' });
      setEditFormVisible(true);
      setUnit(2);
    }
    const onRowEditClick = function(row) {
      setCurrentItem(row);
      setCode(row.code);
      setName(row.name);
      setScoreType(row.scoreType);
      setUnit(row.unit);
      var ss = {name:row.scoreType.title, code: row.scoreType.id.toString()};
      console.log(ss);
      setSelectedScoreType(ss);
      setEditFormVisible(true);        
    }
    const onRowDeleteClick = function(row) {
      setCurrentItem(row);
      setConfirmDeleteVisible(true);
    }

    const closeEditDialog = function(){
      setEditFormVisible(false);
    }
    const deleteItem = function(){
      setDeleting(true);
      var id = currentItem.id;
      var params = {login:util.getTrustedUser(), id:id};
      var url = config.Server+`/basic/course/delete`;
        axios
            .post(url, params )
            .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === id){
                      tmp.splice(i, 1);
                      break;
                    }
                  }
                  setCurrentItem(null);
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setDeleting(false);
                  setConfirmDeleteVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setDeleting(false);
              }
            })
            .catch(error => {
              setDeleting(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }

    const checkDataEntry = function(){
        if((code == 0)||(code == "")||(code == null)){
            setErrorMessage("کد نوع درس را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(name.trim().length == 0){
            setErrorMessage("نوع درس را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if((scoreType == 0)||(scoreType == "")||(scoreType == null)){
            setErrorMessage("نوع نمره درس را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
      if(!checkDataEntry()) return;
      var tempUnit = unit;
      if((unit == 0)||(unit == "")||(unit == null)){
        tempUnit = 1;
      }
      setSaving(true);
      var id = "";
      if(currentItem != null){
        id = currentItem.id;
      }
      var deg = 0;
      if(degree != null) deg = degree;
      var params = {login:util.getTrustedUser(), id:id, code:code, name:name, degree:deg, fieldId:field.id, scoreType:parseInt(selectedScorType.code), unit:tempUnit};
      var url = config.Server+`/basic/course/save`;
      console.log("course is >", params);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  if(id === ""){
                    tmp.push(response);
                  }
                  else{
                    for(var i=0;i<tmp.length;i++){
                      if(tmp[i].id === id){
                        tmp[i] = {
                          id:id, 
                          code:code,
                          name:name,
                           degree:degree, 
                           field:field, 
                           scoreType:{id:parseInt(selectedScorType.code), title:selectedScorType.name},
                           unit:tempUnit,
                        }
                        setCurrentItem(tmp[i]);
                        break;
                      }
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setSaving(false);
                  setEditFormVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{closeEditDialog()}} saving={saving} />
        )
    }
    const onInputChange = function(e, fname){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(fname === "code") setCode(val);
        else if(fname === "name") setName(val);
        else if(fname == "unit") setUnit(val);
        
    }
    const onDegreeChange = function(e){
      if(e.value == null){
        setDegree(0);
      }
      else{
        setDegree(e.value);
      }
      setListVisible(false);
        
    }
    const onComboChange = function(fname, e){
        if(fname === "selectedScorType") {
          setScoreType(parseInt(e.value.code));
          setSelectedScoreType(e.value);
          console.log("s c t>", e.value)
        }
        else if(fname === "field"){
          console.log("field->", e.itemValue)
          setField(e.itemValue);
          setListVisible(false);
        }
    }
    
    const setRowActions = function(row) {
      return(
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-trash" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </Row>
      )
    }


    const scoretypes = [
        { name: 'عددی', code: '1' },
        { name: 'توصیفی', code: '2' },
    ];
    
    return(      
      <>   
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>لیست انواع درس</div>
      <div className="" style={{ width:"calc(100% - 0px)"}}>
        <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
            <Row>
              <Col md={3} style={{paddingTop:"0px"}}>
                <FieldCombo returnFullItem={true} value={field} onChange={(val) => onComboChange('field', val)} />           
              </Col>
              <Col md={3} style={{paddingTop:"30px"}}>
                  <FloatLabel>
                    <InputNumber inputId="integeronly" value={degree} onChange={(e) => onDegreeChange(e)} useGrouping={true}  maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
                    <label htmlFor="username">پایه تحصیلی</label>
                  </FloatLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                  <Button label="مشاهده دروس" icon="pi pi-search" onClick={()=>loadItems()} severity="primary" iconPos="right" />
                </div>
                
              </Col>
            </Row>
        </div>
      </div>
      <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>          
          {
            listVisible?
            <>
          {
            loading?
                    <DataTable value={LoadingRows}  className="p-datatable-striped">
                        <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                        <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                    </DataTable>
            :
              <>
              <Row style={{}}>
                <Col md={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right", margin:"10px" }}>             
                    <Button label="افزودن به لیست" icon="pi pi-plus" onClick={()=>addNewItem()} severity="secondary" iconPos="right" />
                  </div>                
                </Col>
              </Row>
                
              <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown "
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id"  selection={currentItem}  onSelectionChange={(e) => {setCurrentItem(e.value)}}>
                        <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                        <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                        {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                        <Column field="code" header={"کد"} sortable className="list-cell-text-align"></Column>
                        <Column field="name" header={"عنوان"} sortable className="list-cell-text-align"></Column>
                        <Column field="degree" header={"پایه"} sortable className="list-cell-text-align"></Column>
                        <Column field="field.title" body={(row) => row.field.title} header={"رشته"} sortable className="list-cell-text-align"></Column>
                        <Column field="unit" header={"واحد"} sortable className="list-cell-text-align"></Column>
                        <Column field="scoreType.title" body={(row) => row.scoreType.title} header={"نوع نمره"} sortable className="list-cell-text-align"></Column>                        
                        <Column body={(row) => setRowActions(row)} exportable={false} style={{ width:"100px" }}></Column>
                </DataTable>
              </>
          }           
            </>
           :
           <></>
          }
       </div>
       {
        editFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                    header="ثبت مشخصات نوع درس" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
                      <table style={{width:"100%"}}>
                        <tbody>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={code} onChange={(e)=>{onInputChange(e, "code")}} id="code" keyfilter="int" maxLength={8} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">کد درس</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={name} onChange={(e)=>{onInputChange(e, "name")}} id="name" keyfilter="" maxLength={100} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">نام درس</label>
                              </FloatLabel>
                            </td>
                          </tr>
                         <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td>
                              <FloatLabel>
                                <InputNumber inputId="integeronly" value={unit} onValueChange={(e) => setUnit(e.value)} useGrouping={true}  maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
                                  <label htmlFor="username">واحد</label>
                              </FloatLabel>                      
                            </td>
                          </tr>                         
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td>
                            <div className="card flex justify-content-center">
                                <FloatLabel className="w-full md:w-14rem">
                                <Dropdown inputId="dd-city" value={selectedScorType} onChange={(e) => onComboChange("selectedScorType", e)} options={scoretypes} optionLabel="name" className="w-full" />
                                <label htmlFor="dd-city">نوع نمره</label>
                                </FloatLabel>
                            </div>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>

                        </tbody>
                      </table>

        </Dialog>
        :
        <></>
       }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      </>  
    );
}
